import React,{useState, useEffect} from 'react';
import {doGet, doPost, doDelete, doPut} from 'utils/apiUtil.js'
import {endpoint} from 'utils/constants.js'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import DebouncedTextField from 'components/DebouncedTextField.js';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';

const SizeForm =(props)=> {
  const { handleClose, actionType, size, sizeGroup, user, getSizeGroups, clearGroupSizeSelection} = props
  const classes = useStyles();
  const [state, setstate] = useState({})

  const getDefaultHeader =()=>{
    return {"Authorization":`Bearer ${user.token}`}
  }
  
  const handleChange=(fieldName,eventValue)=>{
    let newState = {...state}
    let value = eventValue

    newState[fieldName] = value
    setstate(newState)
  }

  const add=async()=>{
    let sizes = sizeGroup.sizes;
    const payload = {
      name:state.name,
      group_size_id: sizeGroup.id,
      order: sizes.length > 0 ? (sizes[sizes.length-1].order)+1 : 1
    }
    const response = await doPost(endpoint.size, payload,"add size",getDefaultHeader())
    
    if(response && !response.error){
      getSizeGroups()
      handleClose()
    }     
  }

  const edit=async()=>{
    const payload = {
      id:state.id,
      name:state.name,
      group_size_id:state.group_size_id
    }
    const response = await doPut(endpoint.size, payload,"edit size",getDefaultHeader())
    
    if(response && !response.error){
      getSizeGroups()
      handleClose()
      
    }
  }
  
  const submit = ()=>{
    if(actionType==="add"){
        add()
    }else if(actionType==="edit"){
        edit()
    }
  }


  useEffect(() => {
    if(size){
        setstate({
          id:size.id, 
          name:size.name,
          group_size_id:size.group_size_id
        })
    }else{
        setstate({
            name:""
        })
    }
  }, [size])

  return (
    <>
      <DialogContent>      
        <Grid container justify='center' alignItems='flex-start'>
          <DebouncedTextField
            margin="dense"
            id="Name"
            label="Name"
            fullWidth
            value={state.name}
            onChange={(e)=>handleChange("name",e)}
          />
        </Grid> 
        
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Kembali
        </Button>
        <Button variant="contained" onClick={submit} color="primary">
          Simpan
        </Button>
      </DialogActions>
</>

    );
}

export default SizeForm;

const useStyles = makeStyles((theme) => ({

}));
